import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/start-coach/CoachStartClient.tsx");
